import { useLayoutEffect, useState } from 'react';

export const useTableDataHeight = (headerHeight = 0, footerHeight = 0) => {
  const [tableHeight, setTableHeight] = useState(0);

  useLayoutEffect(() => {
    setTableHeight(window.innerHeight - headerHeight - footerHeight);
  }, [footerHeight, headerHeight]);

  return { tableHeight };
};
